export default __webpack_public_path__ + "c468e5e7ead5a291739a7dfc14fe0218.svg";